import React, { createContext, useState, useEffect } from "react";

export const TaskContext = createContext();

export const TaskProvider = ({ children }) => {
  const initialTaskId = localStorage.getItem("taskId") || 0;
  const [taskId, setTaskId] = useState(Number(initialTaskId));
  useEffect(() => {
    localStorage.setItem("taskId", taskId.toString());
  }, [taskId]);
  return (
    <TaskContext.Provider value={{ taskId, setTaskId }}>
      {children}
    </TaskContext.Provider>
  );
};
